const currency = (value: any) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));

export const PFSummaryAppendixJson = [
  { field: "initialFaceAmount", header: "Initial Face Amount", formatter: currency },
  { field: "lapseYear", header: "Lapse Year" },
  { field: "mecYear", header: "MEC Year" },
  { field: "modalPremium", header: "Modal Premium", formatter: currency },
  { field: "minimumPremiumMmp", header: "Minimum Premium (MMP)", formatter: currency },
  {
    field: "deathBenefitProtectionPremiumMgp",
    header: "Death Benefit Protection Premium (MGP)",
    formatter: currency,
  },
  { field: "targetPremium", header: "Target Premium", formatter: currency },
  { field: "mecPremium", header: "MEC Premium", formatter: currency },
  { field: "guidelineLevelPremium", header: "Guideline Level Premium", formatter: currency },
  {
    field: "guidelineSinglePremium",
    header: "Guideline Single Premium",
    formatter: currency,
  },
];
